import Vue from 'vue'
import { listByDictType as getDictDetail } from '@/api/system/dict/dictDetail'

export default class Dict {
  constructor(dict) {
    this.dict = dict
  }

  async init(names, completeCallback) {
    // // 参数校验
    // if (names === undefined || names === null) {
    //   throw new Error('need Dict names')
    // }
    // const ps = []
    // names.forEach(n => {
    //   // 初始化容器（保持响应式）
    //   Vue.set(this.dict.dict, n, {})
    //   Vue.set(this.dict.label, n, {})
    //   Vue.set(this.dict, n, [])
    //   ps.push(getDictDetail(n).then(data => {
    //     const list = Array.isArray(data && data.data && data.data.list) ? data.data.list : []
    //     // 根据 dictValue 去重，避免重复项
    //     const seen = new Set()
    //     const uniqueList = []
    //     list.forEach(d => {
    //       if (!seen.has(d.dictValue)) {
    //         seen.add(d.dictValue)
    //         uniqueList.push(d)
    //       }
    //     })
    //     // 覆盖数组，避免 splice 造成的重复累加问题
    //     Vue.set(this.dict, n, uniqueList)
    //     uniqueList.forEach(d => {
    //       Vue.set(this.dict.dict[n], d.dictValue, d)
    //       Vue.set(this.dict.label[n], d.dictValue, d.dictLabel)
    //     })
    //   }))
    // })
    // await Promise.all(ps)
    // completeCallback()

    // 字典有点问题，先还原逻辑
    if (names === undefined || names === null) {
      throw new Error('need Dict names')
    }
    const ps = []
    names.forEach(n => {
      Vue.set(this.dict.dict, n, {})
      Vue.set(this.dict.label, n, {})
      Vue.set(this.dict, n, [])
      ps.push(getDictDetail(n).then(data => {
        this.dict[n].splice(0, 0, ...data.data.list)
        data.data.list.forEach(d => {
          Vue.set(this.dict.dict[n], d.dictValue, d)
          Vue.set(this.dict.label[n], d.dictValue, d.dictLabel)
        })
      }))
    })
    await Promise.all(ps)
    completeCallback()
  }
}
